// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { xIsAuthenticated } from "@pacific/App/Store/Selectors/GeneralSelectors";
import { getDataLayer } from "@pacific/XDL/Utilities/dataLayer";

export const _GaContactUsFormSubmit: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState();
    const currentPage = getCurrentPage(state);
    const isPDP = currentPage.type === "ProductDetailsPage";

    let event = "contact_us_submit";
    let productState = null;
    if (isPDP) {
        event = "pdp_feedback";
        const productId = state.pages.productDetails.selectedProductId;
        productState = getProductState(state, productId)?.value;
    }
    const session = getSession(state);
    const currentBillTo = getCurrentBillToState(state).value;
    const isAuthenticated = xIsAuthenticated(state);
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const googleAnalyticsData = {
        event,
        ...(productState && {
            item_id: productState.productNumber,
            item_name: productState.productTitle,
        }),
        authentication_state: isAuthenticated ? "Authenticated" : "Guest",
        affiliation: currentBillTo?.companyName || "",
        company_name: (props.apiParameter as any).companyName,
        topic: (props.apiParameter as any).topic,
        email: (props.apiParameter as any).emailAddress,
        sales_rep: (session as any).salesperson?.name || "",
    };
    dataLayer.push(googleAnalyticsData);
};

addToChainAfter(chain, ExecuteOnSuccessCallback, _GaContactUsFormSubmit);
